import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import {
  isProviderCommissionBiggerThanMinPrice,
  isOutsideServiceAreaError,
  isInvalidLocationError,
  isProviderNotSetShippingPriceError,
} from '../../../util/errors';

import css from './FetchLineItemsError.module.css';
import classNames from 'classnames';

/**
 * An error text displayed when provider minimum commission value is higher than that of the listing's price
 *
 * @component
 * @param {Object} props
 * @param {Object} [props.error] - Ther error object
 * @returns {JSX.Element}
 */
const FetchLineItemsError = props => {
  const { error, promotionValidation } = props;
  const hasError = !!error;
  const hasPromotionCodeError = promotionValidation?.type === 'promotion-code-error';
  return hasPromotionCodeError ? (
    <div className={classNames(css.error, css.promotionCodeError)}>
      {promotionValidation.message}
    </div>
  ) : hasError && isProviderCommissionBiggerThanMinPrice(error) ? (
    <div className={css.error}>
      <FormattedMessage id="FetchLineItemsError.providerCommissionBiggerThanMinPrice" />
    </div>
  ) : hasError && isOutsideServiceAreaError(error) ? (
    <div className={css.error}>
      <FormattedMessage id="FetchLineItemsError.outsideServiceArea" />
    </div>
  ) : hasError && isInvalidLocationError(error) ? (
    <div className={css.error}>{error.statusText}</div>
  ) : hasError && isProviderNotSetShippingPriceError(error) ? (
    <div className={css.error}>
      <FormattedMessage id="FetchLineItemsError.providerNotSetShippingPrice" />
    </div>
  ) : hasError ? (
    <div className={css.error}>
      <FormattedMessage id="FetchLineItemsError.unknownError" />
    </div>
  ) : null;
};

export default FetchLineItemsError;
